import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const axiosWithCredentials = axios.create({
  withCredentials: true,
});

export const PAINEL_TABS = ['vendedores', 'leads', 'projetos', 'metricas'];

export const PAINEL_TAB_LABELS = {
  vendedores: 'Vendedores',
  leads: 'Leads',
  projetos: 'Projetos',
  metricas: 'Métricas',
};

export const painelApiClient = axiosWithCredentials;

export const fetchPainelAdminData = async () => {
  const [vendedoresRes, metricsRes, projectsRes] = await Promise.all([
    axiosWithCredentials.get(`${API}/vendedores`),
    axiosWithCredentials.get(`${API}/admin/vendedores/metrics`),
    axiosWithCredentials.get(`${API}/projects`),
  ]);

  return {
    vendedores: vendedoresRes.data,
    metrics: metricsRes.data,
    projects: projectsRes.data,
  };
};

export const fetchPainelAdminLeads = async (vendedorId) => {
  const response = await axiosWithCredentials.get(`${API}/vendedores/${vendedorId}/leads`);
  return response.data;
};
